export enum EMessageType {
	INFO = 'info',
	WARN = 'warn',
	ERROR = 'error'
}
